import { CurrencyKrwIcon } from './CurrencyKrwIcon';

/**
 * author: Haley Halcyon
 * id 72750D9E-229F-4D77-B1CB-9C2C0FD12335
 * name currency-krw
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-krw.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const WonIcon = CurrencyKrwIcon;
export default WonIcon